
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { PERMISSION } from '@/permissions';
import ActionSheetItem from './ActionSheetItem.vue';

@Component<ActionSheet>({
	components: {
		ActionSheetItem
	}
})
export default class ActionSheet extends Vue {
	@Prop({ type: Boolean, default: false }) private actionSheetOpened!: boolean;
	@Prop({ type: Object, default: () => {} }) private item!: Menu | MenuSection | MenuItem;
	@Prop({ type: Array, default: () => [] }) private actionsArray!: ActionItem[];
	@Prop({ type: Boolean, default: false }) private override!: boolean;
	@Getter('hasPermission', { namespace: 'auth' }) private hasPermission!: (permission: PERMISSION) => boolean;

	private mutableActionsArray: ActionItem[] = this.actionsArray;

	private mounted(): void {
		if (this.item.published_at) {
			this.mutableActionsArray = this.mutableActionsArray.filter(mutableAction => mutableAction.buttonLabel !== this.$t('shared.actions_array.btn_publish'));
		}
		else {
			this.mutableActionsArray = this.mutableActionsArray.filter(mutableAction => mutableAction.buttonLabel !== this.$t('shared.actions_array.btn_archive'));
		}
	}

	/**
	 * Determines if an action should be disabled, either by the current role's permissions
	 * (`action.permission`, which handles POS internally) or by the action's own `disabled` option.
	 *
	 * @param {ActionItem} action - the action being rendered
	 * @return {boolean} true if the action should be disabled
	 */
	private isItemDisabled(action: ActionItem): boolean {
		if (action.permission !== undefined && !this.hasPermission(action.permission)) {
			return true;
		}
		return typeof action.disabled === 'function' ? action.disabled(this.item) : !!action.disabled;
	}

	private closeActionSheet() : void {
		this.$emit('close-action-sheet');
	}
}
